import { LoadingButton } from '@mui/lab';
import { Grid, Menu, MenuItem, Stack, Typography } from '@mui/material';
import { DateRangePicker } from 'pages/raas/components';
import { TxPoolMetric } from 'pages/raas/DeploymentDetails/views/OverviewView/TxPoolMetric';
import { RollupType } from 'pages/raas/helpers/labels';
import { isOrbit } from 'pages/raas/helpers/rollup';
import { useRaasDeployment } from 'pages/raas/hooks';
import { useOrbitInstances } from 'pages/raas/hooks/orbit/useOrbitInstances';
import { useEffect, useState } from 'react';
import { AnimatedIconChevronDown } from 'shared/components/icons/AnimatedIconChevronDown';
import { MetricGridItem } from 'shared/components/metric/MetricGridItem';
import { Section } from 'shared/components/Section';
import { useMenuDisclosure } from 'shared/hooks/ui/useMenuDisclosure';

import { DateFilterVariant } from '../../store';
import { CPUMetric } from './CPUMetric';
import { MemoryMetric } from './MemoryMetric';

export const BlockchainStatisticsView = () => {
  const { data: rollup } = useRaasDeployment();
  const { data: orbitInstances, isLoading: isLoadingOrbitInstances } = useOrbitInstances();

  console.log('PODS', orbitInstances);

  const [selectedPod, setSelectedPod] = useState<string | undefined>(
    orbitInstances?.batcherPosterPod,
  );

  const {
    anchorEl: podsMenuAnchorEl,
    onClose: onClosePodsMenu,
    onOpen: onOpenPodsMenu,
    open: openedPodsMenu,
  } = useMenuDisclosure();

  const handleSelectPod = (pod: string) => {
    setSelectedPod(pod);
    onClosePodsMenu();
  };

  useEffect(() => {
    if (!selectedPod && orbitInstances && Object.values(orbitInstances).length > 0) {
      setSelectedPod(orbitInstances?.batcherPosterPod);
    }
  }, [orbitInstances, selectedPod]);

  return (
    <>
      <Section
        renderContent={
          <Stack spacing={2} sx={{ px: { md: 5, sm: 3, xs: 3 }, pt: { md: 3 } }}>
            {isOrbit(rollup?.type as RollupType) && (
              <>
                <LoadingButton
                  loading={isLoadingOrbitInstances}
                  onClick={onOpenPodsMenu}
                  sx={theme => ({
                    backgroundColor: 'transparent !important',
                    '&, &:hover': {
                      background: '#fff',
                      color: theme.colors.functional.text.primary,
                      p: 0,
                    },
                    width: '350px',
                  })}
                >
                  <Stack direction="row" spacing="32px" sx={{ p: '16px' }}>
                    <Typography variant="bodySmallM">{selectedPod}</Typography>
                    <AnimatedIconChevronDown open={openedPodsMenu} />
                  </Stack>
                </LoadingButton>
                <Menu anchorEl={podsMenuAnchorEl} onClose={onClosePodsMenu} open={openedPodsMenu}>
                  {Object.values(orbitInstances ?? {}).map(pod => (
                    <MenuItem key={pod} onClick={() => handleSelectPod(pod)}>
                      {pod}
                    </MenuItem>
                  ))}
                </Menu>
              </>
            )}

            <Grid container>
              {!isOrbit(rollup?.type as RollupType) && (
                <MetricGridItem item>
                  <TxPoolMetric
                    dateFilterVariant={DateFilterVariant.BLOCKCHAIN_STATS_GENERAL_SECTION}
                  />
                </MetricGridItem>
              )}

              <MetricGridItem item>
                <CPUMetric
                  instance={isOrbit(rollup?.type as RollupType) ? selectedPod : undefined}
                />
              </MetricGridItem>
              <MetricGridItem item>
                <MemoryMetric
                  instance={isOrbit(rollup?.type as RollupType) ? selectedPod : undefined}
                />
              </MetricGridItem>
            </Grid>
          </Stack>
        }
        renderSubHeaderEndContent={
          <DateRangePicker variant={DateFilterVariant.BLOCKCHAIN_STATS_GENERAL_SECTION} />
        }
        sectionContentSx={{ p: 0 }}
        title="Blockchain Statistics"
      />
    </>
  );
};
